import { toast } from 'sonner'

import { AXIOS_INSTANCE } from '@/shared/api/axios-client'
import { usePostUsersAuth } from '@/shared/api/generated/hooks/usePostUsersAuth'
import { getErrorMessage } from '@/shared/model'

import { useAuthTokenSetter } from '../../model/hooks/use-auth-token.setter'

export const useLogin = () => {
    const { tokenSetter } = useAuthTokenSetter()

    const {
        mutate: login,
        mutateAsync: loginAsync,
        isPending,
    } = usePostUsersAuth({
        mutation: {
            onSuccess: async ({ access_token }) => {
                AXIOS_INSTANCE.defaults.headers.Authorization = `Bearer ${access_token}`

                tokenSetter(access_token)

                toast.success('Вы успешно авторизовались')
            },
            onError: (error) => {
                toast.error(getErrorMessage(error.error_code))
            },
        },
    })

    return {
        login,
        loginAsync,
        isPending,
    }
}
